export default "__VITE_ASSET__CWgZdxEp__"